
export default {
  name: 'ProgressBar',

  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: Number,
      default: 0,
    },
    trackedElementSelector: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      value: 0,
      trackedElement: null,
    };
  },

  mounted() {
    this.trackedElement = document.querySelector(this.trackedElementSelector);
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      const trackedElementRect = this.trackedElement.getBoundingClientRect();

      // top < 0 means that the element passed the top window edge and the scroll progress can be calculated
      if (trackedElementRect.top < 0) {
        const progress =
          (Math.abs(trackedElementRect.top) /
            (trackedElementRect.height - this.offset)) *
          100;

        this.value = progress;

        this.$emit('progress-change', progress);
      } else {
        this.value = 0;
      }
    },
  },
};
